import React from 'react';
import { Row, Col, Alert, Icon, Tag } from 'antd';
import { connect } from 'dva';
import styles from './SelectedCommodities.less';

@connect(({ operationChargeItemPublishChargeItemSteps }) => ({
  selectedRows: operationChargeItemPublishChargeItemSteps.selectedRows,
}))
export default class SelectedCommodities extends React.Component {
  handleRemoveSelectedRow(row) {
    const { selectedRows } = this.props;

    const newSelectedRows = [];
    const newSelectedRowKeys = [];
    selectedRows.forEach(selectedRow => {
      if (selectedRow.commodityId !== row.commodityId) {
        newSelectedRows.push(selectedRow);
        newSelectedRowKeys.push(selectedRow.commodityId);
      }
    });

    this.props.dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/saveSelectedData',
      selectedRowKeys: newSelectedRowKeys,
      selectedRows: newSelectedRows,
    });
  }

  renderSelectedCommodities() {
    const { selectedRows } = this.props;

    return selectedRows.map(row => (
      <Tag closable key={row.commodityId} onClose={this.handleRemoveSelectedRow.bind(this, row)}>
        {row.name}
      </Tag>
    ));
  }

  render() {
    const { selectedRows } = this.props;

    return (
      <Row className={styles.root}>
        <Col span={24} className="ant-alert ant-alert-info ant-alert-no-icon">
          <span className="ant-alert-message">
            <Icon type="info-circle-o" className="info-icon" />
            已选商品数：<span className="selected-number">{selectedRows.length}</span>
            {this.renderSelectedCommodities()}
          </span>
          <Alert style={{ display: 'none' }} />
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step1/SelectedCommodities.js